<script setup lang="ts">
import ToastRegion from "@/components/ToastRegion.vue"
</script>

<template>
  <RouterView />
  <ToastRegion />
</template>
